// extracted by mini-css-extract-plugin
export default {"dashboard":"StatisticsDashboard_dashboard__9Hme4"};